var cov_1zzhxacb2a = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/styles/index.ts",
      hash = "afc4b4aa9a3fb683e06c01f5436e994826996917",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Carousel/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var carouselLess = {};
import genaration from '../../utils/classname';
export var carouselClass = (cov_1zzhxacb2a.s[0]++, genaration(carouselLess, 'carousel'));